<template>
  <div>
    <PromotionHeader :img_header="header_image" header="จัดชุดโปรโมชั่นใหม่" link_back="stock/promotion_stock/promotionset"/>
    <Promotion_add/>
  </div>
</template>

<script>
import PromotionHeader from "@/components/admin/stock/storage_promotion/header_promotion/PromotionHeader";
import Promotion_add from "@/components/admin/stock/storage_promotion/Promotion_add";
import HeaderImage from "@/assets/boxes_set.png";
export default {
  name: "PromotionAdd",
  components: {
    Promotion_add,
    PromotionHeader
  },
  data() {
    return {
      header_image: HeaderImage,
    }
  },
}
</script>

<style scoped>

</style>
